import { CancelToken } from 'axios'
import RequestFactory from './RequestFactory'
import { ResultModel } from '../models/result.model'
import { TemplateModel } from '../models/epic/Template.model'

const epicIntegrationUrl = process.env.REACT_APP_GMAE2E_URL

const EpicIntegrationService = {
  getTemplateInfo: async (templateId: string, cancelToken?: CancelToken) => {
    return (await RequestFactory.get(
      epicIntegrationUrl,
      `/api/epic-integration/get-template-info?templateId=${templateId}`,
      () => {
        if (cancelToken === undefined) return undefined

        return {
          cancelToken,
        } as any
      }
    )) as Promise<ResultModel<TemplateModel[]>>
  },
  downloadDocument: async (model: any) =>
    await RequestFactory.downloadRaw(
      epicIntegrationUrl,
      '/api/epic-integration/generate-document',
      model
    ),
}

export default EpicIntegrationService
